<template>
  <!--<nav class="header">Quizzes</nav>-->
    <v-app-bar color="primary" dark height="75px" style="margin-bottom: 3rem;">
        <v-img :src='require("@/assets/THON_Quizzes_Logo.png")' max-height="75" max-width="125" contain></v-img>
    </v-app-bar>
</template>

<script>
export default {
  name: "AppHeader"
}
</script>
<style scoped>
.header{
    background-color: #14245f ;
    color: #ffffff;
    font-size: 35px;
    text-align:left;
    padding: 5px 0 5px 20px;
    margin-bottom: 5rem;
    font-weight: 600;
}
</style>